export const PERSONAL_INFO_PAGE_PREFIX = 'personal-info-page';
export const PERSONAL_CONSENT_PAGE_PREFIX = 'personal-consent-page';
export const RESULTS_PAGE_PREFIX = 'results-page';
export const FINAL_PAGE_PREFIX = 'final-page';
